import '../assets/NcActionButtonGroup-BND4GQdv.css';
import { defineComponent } from "vue";
import { G as GenRandomId } from "./GenRandomId-CMooMQt0.mjs";
import { r as register, a as t } from "./_l10n-DIOHNc85.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
register();
const _sfc_main = defineComponent({
  name: "NcActionButtonGroup",
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: false
    }
  },
  props: {
    /**
     * Optional text shown below the button group
     */
    name: {
      required: false,
      default: void 0,
      type: String
    }
  },
  setup() {
    return {
      labelId: `nc-action-button-group-${GenRandomId()}`
    };
  },
  methods: {
    t
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("li", { staticClass: "nc-button-group-base", attrs: { "role": _vm.isInSemanticMenu && "presentation" } }, [_vm.name ? _c("div", { attrs: { "id": _vm.labelId } }, [_vm._v(" " + _vm._s(_vm.name) + " ")]) : _vm._e(), _c("ul", { staticClass: "nc-button-group-content", attrs: { "role": "group", "aria-labelledby": _vm.name ? _vm.labelId : void 0 } }, [_vm._t("default")], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcActionButtonGroup = __component__.exports;
export {
  NcActionButtonGroup as N
};
//# sourceMappingURL=NcActionButtonGroup-BkU5oOmB.mjs.map
